<template>
	<section class="select-section">
		<el-dialog :visible.sync="dialogVisible" width="70%" center min-width="750px">
			<p slot="title">{{title}}</p>
      <div class="search-row">
        <el-input placeholder="请输入内容" v-model="searchVal" class="input-with-select" @keyup.enter='getData' size='small' clearable>
        </el-input>
        <el-button type="primary" size='small'
                   @click='currentPage=1;getData()'>搜索</el-button>
      </div>
      <el-table :data="tableData" class="table_list" top='10vh' style="width: 100%" border max-height="500"
        @row-click='rowClickHandle'>
				<el-table-column label="选择" width="50px" align="center">
					<template slot-scope="scope">
						<div class="virtualBox"></div>
						<el-checkbox v-model="choiceRow" :label="scope.row">
							{{ }}
						</el-checkbox>
					</template>
				</el-table-column>
				<el-table-column label="试卷名称" min-width="40%">
					<template slot-scope="scope">
						<span>{{scope.row.quiz.quizName}}</span>
					</template>
				</el-table-column>
				<el-table-column label="题数" min-width="5%">
					<template slot-scope="scope">
						<span>{{scope.row.quiz.quizCount}}</span>
					</template>
				</el-table-column>
				<el-table-column label="满分" min-width="5%">
					<template slot-scope="scope">
						<span>{{scope.row.quiz.totalScore}}</span>
					</template>
				</el-table-column>
				<el-table-column label="合格分" min-width="5%">
					<template slot-scope="scope">
						<span>{{scope.row.quiz.passScore}}</span>
					</template>
				</el-table-column>
				<el-table-column label="关联病种" min-width="10%">
					<template slot-scope="scope">
						<span>{{scope.row.knowledgeText || '-'}}</span>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination-wrap">
				<el-pagination class='el-pagination' @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50]"
					:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
				</el-pagination>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitHandle">确 定</el-button>
			</span>
		</el-dialog>
	</section>
</template>

<script scoped>
	import requestApi from "@/api/selectSource"
	export default {
		name: "selectCamp",
		data() {
			return {
				title: "",
				choiceRow: [],
				dialogVisible: false,
				searchVal: "",
				pageSize: 20,
				currentPage: 1,
				totalCount: 0,
				tableData: []
			};
		},
		props: {
			isSingle: {
				type: Boolean,
				default: () => true
			}
		},
		mounted() {},
		methods: {
			open(title) {
				this.choiceRow = []
				if (this.tableData.length == 0) {
					this.getData()
				}
				this.dialogVisible = true;
				this.title = title;
			},
			close() {
				this.dialogVisible = false;
			},
			submitHandle() {
				if (!this.choiceRow.length) { return }
				if (this.isSingle) {
					this.$emit('select-submit', this.choiceRow[0] || {})
				} else {
					this.$emit('select-submit', this.choiceRow)
				}
				this.dialogVisible = false;
			},
			rowClickHandle(row) {
				if (this.isSingle) {
					this.choiceRow = [row]
				} else {
					var index = this.choiceRow.indexOf(row)
					if (index == -1) {
						this.choiceRow.push(row)
					} else {
						this.choiceRow.splice(index, 1)
					}
				}
			},
			getData() {
				let requestData = {
					pageIndex: this.currentPage,
					pageSize: this.pageSize,
					type: 10,
          searchKey: 10,
          searchValue: this.searchVal
				}
				requestApi.courseOrgin(requestData).then(res => {
					this.tableData = res.Data.dataList
					this.totalCount = res.Data.totalCount
			  		this.choiceRow = []
				}).catch(res => {
					console.log(res)
					this.$message.error('获取列表信息出错，请稍后再试！')
				})
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.getData();
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData();
			}
		}
	};
</script>

<style type="text/less" lang="less" scoped>
	.avatar {
  width: 60px;
  background-size: 100% 100%;
}
.select-section {
	.el-dialog__wrapper {
		background-color: rgba(0, 0, 0, 0.1);
	}
	.pagination-wrap {
		margin-top: 10px;
	}
	.el-pagination {
		float: right;
	}
	.dialog-footer {
		margin-top: 40px;
	}
}
.search-row {
	margin-bottom: 10px;
	text-align: right;
	.input-with-select {
		width: 30%;
		min-width: 350px;
	}
	.search-select {
		width: 110px;
	}
}
.virtualBox{
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 9;
}
</style>
<style type="text/css">
	.el-table .cell {
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/selectSource/selectPaper.vue